var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const coreWasms = {
    bundler: () => __awaiter(void 0, void 0, void 0, function* () { return yield import("./core/bridge"); }),
    node: () => __awaiter(void 0, void 0, void 0, function* () { return yield import("./core-node/bridge"); }),
};
const migrationWasms = {
    bundler: () => __awaiter(void 0, void 0, void 0, function* () { return yield import("./migration/wormhole_migration"); }),
    node: () => __awaiter(void 0, void 0, void 0, function* () { return yield import("./migration-node/wormhole_migration"); }),
};
const nftWasms = {
    bundler: () => __awaiter(void 0, void 0, void 0, function* () { return yield import("./nft/nft_bridge"); }),
    node: () => __awaiter(void 0, void 0, void 0, function* () { return yield import("./nft-node/nft_bridge"); }),
};
const tokenWasms = {
    bundler: () => __awaiter(void 0, void 0, void 0, function* () { return yield import("./token/token_bridge"); }),
    node: () => __awaiter(void 0, void 0, void 0, function* () { return yield import("./token-node/token_bridge"); }),
};
let importDefaultCoreWasm = coreWasms.bundler;
let importDefaultMigrationWasm = migrationWasms.bundler;
let importDefaultNftWasm = nftWasms.bundler;
let importDefaultTokenWasm = tokenWasms.bundler;
export function setDefaultWasm(type) {
    importDefaultCoreWasm = coreWasms[type];
    importDefaultMigrationWasm = migrationWasms[type];
    importDefaultNftWasm = nftWasms[type];
    importDefaultTokenWasm = tokenWasms[type];
}
export function importCoreWasm() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield importDefaultCoreWasm();
    });
}
export function importMigrationWasm() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield importDefaultMigrationWasm();
    });
}
export function importNftWasm() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield importDefaultNftWasm();
    });
}
export function importTokenWasm() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield importDefaultTokenWasm();
    });
}
